var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { mockData as allUsers } from '@web/lib/demo/data/users';
import { getUsers } from '@web/lib/demo/utils';
import { getTeamMemberIds, randomInt } from '@workalizer/shared/utils';
var generateMeetingAnalyticMetrics = function (scopeMultiplier) {
    var durationSeconds = randomInt(42, 96) * 3600 * scopeMultiplier + randomInt(0, 59) * 60;
    var dailyAvgDurationPerUser = randomInt(48, 135) * 60;
    var recurringMeetingsDuration = randomInt(20, 58) * 3600 + randomInt(0, 45) * 60;
    var scheduledMeetingsParticipationRate = randomInt(71, 94);
    return {
        durationSeconds: durationSeconds,
        dailyAvgDurationPerUser: dailyAvgDurationPerUser,
        recurringMeetingsDuration: recurringMeetingsDuration,
        scheduledMeetingsParticipationRate: scheduledMeetingsParticipationRate
    };
};
var generateTeamAverage = function () { return ({
    durationSeconds: randomInt(38, 88) * 3600 + randomInt(0, 45) * 60,
    dailyAvgDurationPerUser: randomInt(42, 118) * 60,
    recurringMeetingsDuration: randomInt(18, 52) * 3600 + randomInt(0, 30) * 60,
    scheduledMeetingsParticipationRate: randomInt(68, 90)
}); };
export var meetingAnalytic = function (input) {
    var _a, _b, _c, _d;
    var users = getUsers({
        orgUnitId: input.orgUnitId,
        userId: input.userId
    });
    var scopeMultiplier = input.userId ? 1 : Math.max(users.length, 3);
    var data = generateMeetingAnalyticMetrics(scopeMultiplier);
    if (!input.userId) {
        return __assign(__assign({}, data), { teamAverage: null });
    }
    var orgUnitId = (_a = input.orgUnitId) !== null && _a !== void 0 ? _a : (_d = (_c = (_b = allUsers.find(function (user) { return user.id === input.userId; })) === null || _b === void 0 ? void 0 : _b.userOrgUnits) === null || _c === void 0 ? void 0 : _c[0]) === null || _d === void 0 ? void 0 : _d.orgUnit.id;
    var teamUserIds = getTeamMemberIds(allUsers
        .filter(function (user) {
        var _a;
        return orgUnitId
            ? (_a = user.userOrgUnits) === null || _a === void 0 ? void 0 : _a.some(function (unit) { return unit.orgUnit.id === orgUnitId; })
            : true;
    })
        .map(function (user) { return user.id; }), input.userId);
    if (teamUserIds.length === 0) {
        return __assign(__assign({}, data), { teamAverage: null });
    }
    return __assign(__assign({}, data), { teamAverage: generateTeamAverage() });
};
